import { useMemo } from 'react';

import { adminSidebar, clubSidebar, organizerSidebar, playerSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';

import DashboardLayout from '../../components/layout/DashboardLayout';
import SecuritySettingsPanel from '../../components/security/SecuritySettingsPanel';
import PageHeader from '../../components/ui/PageHeader';

export default function ProfileSecurity() {
  const user = useAuthStore(s => s.user);

  const sidebarConfig = useMemo(() => {
    switch (user?.role) {
      case 'SUPER_ADMIN':
        return adminSidebar;
      case 'CLUB_ADMIN':
        return clubSidebar;
      case 'ORGANIZATION_ADMIN':
        return organizerSidebar;
      default:
        return playerSidebar;
    }
  }, [user?.role]);

  return (
    <DashboardLayout sidebarConfig={sidebarConfig}>
      <div className='p-8'>
        <PageHeader
          title='Sécurité du compte'
          subtitle='Gérez la double authentification et les appareils de confiance'
        />
        <SecuritySettingsPanel />
      </div>
    </DashboardLayout>
  );
}
